import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyboardBypassDirective } from './directives/keyboard-bypass.directive';

@NgModule({
  declarations: [KeyboardBypassDirective],
  exports: [KeyboardBypassDirective],
  imports: [CommonModule],
})
export class KeyboardModule {}
